<template>
  <div class="introduction container-content">
    <div class="introduce-headline">
      平台介绍
    </div>
    <div class="entirety">
      <div class="terrace-background">
        <div class="background-headline">
          平台背景
        </div>
        <div class="background-word">
          NQI 综合服务信息系统是一个面向全国的综合服务信息平台，旨在为政府、机构和企业提供计量、标准、认证认可、检验检测等一站式服务。系统基于双边资源整合模式，聚集大量的用户与服务提供机构，既为服务提供机构整合用户资源，又为用户整合来自不同提供机构的服务资源。提高服务资源的可用性与可操作性，畅通和简化市场与相关机构之间的信息交流，实现多个技术机构、多个部门协调合作，开展有效的综合服务工作，使各技术机构和部门的资源得到最优配
          置和整合，从而获取更快、更高的效益和效率。
        </div>
        <div class="background-word">
          NQI 综合服务信息系统开发的总目标是应用当前主流大数据手段，整合梳理NQI 数据与用户行为数据，将实际业务与数据模型结合，开发出同时满足用户NQI 业务一站式查询和汇聚多要素的智能化综合服务平台。
        </div>
      </div>
      <div class="terrace-mission">
        <div class="background-headline">
          平台使命
        </div>
        <div class="background-word">
          <ul>
            <li>国家质量基础(NQI)为核心的一站式公共服务平台。</li>
            <li>该平台是以计量，标准，认证认可，检测检验四大类服务为主题。</li>
            <li>为用户提供全面性，准确性，可靠性，权威性，安全的基础质量数据。</li>
            <li>高效，便捷，优质，协同，共享为理念</li>
            <li>采用创新“互联网+质量服务”模式，开展一站式服务，为大众创业、万众创新提供优质公共技术服务。</li>
            <li>构建质量分析数据库，为国家质量强国战略提供强有力的数据支持。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'introduction',
  mounted () {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  }
}
</script>

<style lang="less" scoped>
.introduction {
  width: @body-width;
  margin: 6px auto;
  .introduce-headline{
    border-left: 4px solid @color-base;
    border-bottom: 1px solid rgba(@color-base, 0.2);
    width: @body-width;
    height: 60px;
    background: rgba(@color-base, 0.1);
    line-height: 60px;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    padding-left: 40px;
  }
  .entirety{
    margin-top: 16px;
    padding: 10px 40px;
    background-color: #fff;
    .terrace-background{
      .background-headline{
        margin: 20px 0 26px 30px;
        padding-left: 10px;
        line-height: 26px;
        font-weight: 600;
        font-size: 18px;
        border-left: 4px solid @color-base;
      }
      .background-word{
        padding-left: 30px;
        font-size: 16px;
        text-indent:32px;
        line-height: 32px;
      }
    }
    .terrace-mission{
      height: 300px;
      padding-left: 40px;
      .background-headline{
        margin: 40px 0 26px -14px;
        padding-left: 10px;
        line-height: 26px;
        font-weight: 600;
        font-size: 18px;
        border-left: 4px solid @color-base;
      }
      .background-word{
        ul li{
          list-style:disc;
          font-size: 16px;
          line-height: 32px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/introduction/index.vue